export default __webpack_public_path__ + "static/media/truck.58ed871a.svg";